// extracted by mini-css-extract-plugin
module.exports = {"editIcon":"FormItem_editIcon_BMvkG"};